<template>
  <div class="widget-container" :class="{ 'widget-container--mobile': mobile }">
    <!-- Header -->
    <div class="widget-header" :class="{ 'widget-header--mobile': mobile }">
      <div class="widget-header__inner" :class="{ 'widget-header__inner--mobile': mobile }">
        <span class="widget-title" :class="{ 'widget-title--mobile': mobile }">Colas</span>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="widget-search"
          single-line
          hide-details
          dense
        ></v-text-field>
        <span @click="goAllQueues" class="widget-link" :class="{ 'widget-link--mobile': mobile }">Ver todas</span>
      </div>
      <v-divider></v-divider>
    </div>
    <!-- List -->
    <div class="widget-list" :class="{ 'widget-list--desktop': !mobile }">
      <v-data-table
        @click:row="goQueue"
        hide-default-footer
        hide-default-header
        :search="search"
        :headers="headersQueues"
        :items="arrQueues"
        :items-per-page="arrQueues.length"
        :mobile-breakpoint="mobile ? 0 : undefined"
        :dense="mobile"
      >
        <template v-slot:item.icon="{ item }">
          <v-icon color="admiraGreen">{{ item.icon }}</v-icon>
        </template>
      </v-data-table>
      <div v-if="!mobile" class="widget-spacer"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "QueuesList",
  data: () => ({
        search: '',
        mobile: false,
  }),
  components: {},
  computed: {
    ...mapState("queues", ["allQueues","spaceSelected"]),
    ...mapState("app", ["actualProject"]),

    headersQueues() {
      return [
        { text: "icon", value: "icon", align: "start" },
        { text: "nombre", value: "name" },
        { text: "tipo", value: "typeName" },
      ];
    },
    arrQueues() {
      let icons = [
        { id: 1, code: "mdi-human-male-male" },
        { id: 2, code: "mdi-ticket-outline" },
        { id: 3, code: "mdi-ticket-confirmation" },
      ];
      let typeNames = [
        { id: 1, name: "Fila" },
        { id: 2, name: "Ticket" },
        { id: 3, name: "Multipuesto" },
      ];
      
            let allQueues = this.allQueues;

      allQueues = allQueues.filter(
          queues => queues.space == this.spaceSelected.idSpace
        );
      return allQueues.map((queue) => {
        const icon = icons.find((icon) => icon.id == queue.type) || {};
        const typeName =
          typeNames.find((typeNames) => typeNames.id == queue.type) || {};

        return {
          ...queue,
          icon: icon.code,
          typeName: typeName.name,
        };
      });
    },
  },
  methods: {
    ...mapActions("queues", ["editQueueStore"]),
    goAllQueues() {
       var mobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
      }
    };
        
    if(mobile.any() != null){
this.$router.push({
        name: "QueuesMobile",
      });    }else{
this.$router.push({
        name: "Queues",
      });    
      }
      
    },
    async goQueue(resource) {
      await this.editQueueStore(resource.idQueue);
      if (this.mobile == true) {
              this.$router.push({
        name: "QueueDetailsMobile",
        params: { idQueue: resource.idQueue },
      });
      }else{
      this.$router.push({
        name: "QueueDetails",
        params: { idQueue: resource.idQueue },
      });
      }

    },
  },
  created() {
     var mobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
      }
    };
        
    if(mobile.any() != null){
        this.mobile = true
    }else{
      this.mobile = false
    }
  },
  mounted() {},
  destroyed() {},
};
</script>

<style scoped>
.widget-container {
  display: flex;
  flex-direction: column;
  height: calc(36vh);
  overflow: hidden;
}
.widget-container--mobile {
  height: auto;
  max-height: 40vh;
}
.widget-header {
  flex-shrink: 0;
  padding: 0 16px;
}
.widget-header--mobile {
  padding: 8px 16px;
}
.widget-header__inner {
  display: flex;
  align-items: center;
  padding: 12px 0;
}
.widget-header__inner--mobile {
  padding: 0;
}
.widget-title {
  color: #777;
  font-size: 18px;
  white-space: nowrap;
}
.widget-title--mobile {
  font-size: 16px;
}
.widget-search {
  flex: 1;
  margin: 0 12px;
}
.widget-link {
  font-size: 15px;
  color: #777;
  cursor: pointer;
  white-space: nowrap;
}
.widget-link--mobile {
  font-size: 13px;
}
.widget-list {
  flex: 1;
  overflow: auto;
  padding: 4px 16px;
}
.widget-list--desktop {
  margin: 0 8px 0 0;
  padding: 0 8px 16px 16px;
}
.widget-spacer {
  height: 16px;
}
>>> td {
  border: none !important;
}
>>> th {
  vertical-align: top;
}
>>> tr {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/QueuesList.vue